export default __webpack_public_path__ + "static/media/element_26.5d921701.webp";